import { Component, OnDestroy } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { ReportingService } from '../reporting.service';
import { AutoRunSnapshot } from '../models/auto-run-report-snapshots.model';

@AutoUnsubscribe()
@Component({
    selector: 'DeleteSnapshot',
    templateUrl: './confirm-delete-snapshot.component.html',
    styleUrls: ['./confirm-delete-snapshot.component.css']
})

export class ConfirmDeleteSnapshotComponent implements OnDestroy {

    // private reportService: ReportingService;

    // @Output() deleteSnapshotEvent: EventEmitter<boolean> = new EventEmitter();

    private snapshotToDelete: AutoRunSnapshot;

    private _reportName: string;
    private _autoRunDate: Date;

    get reportName(): string {
        return this._reportName;
    }

    set reportName(value: string) {
        this._reportName = value;
    }

    get autoRunDate(): Date {
        return this._autoRunDate;
    }

    set autoRunDate(value: Date) {
        this._autoRunDate = value;
    }


    constructor(
        private reportService: ReportingService,
        private dialogRef: MatDialogRef<ConfirmDeleteSnapshotComponent>
    ) {

        this.snapshotToDelete = reportService.autoRunSnapshot;

        this.autoRunDate = this.snapshotToDelete.TimeStamp;
        this.reportName = this.snapshotToDelete.ReportName;
    }

    okClick() {

        const snapshotId = this.snapshotToDelete.AutoRunReportSnapshots_ID;

        this.reportService.deleteReportSnapshot(snapshotId).subscribe(res => {

            // todo: check that the delete was successful
            this.reportService.autoRunSnapshot = null;
            // this.deleteSnapshotEvent.emit(true);

            // if (this.reportService.inDebugMode) {

            // }
        });

        // flag that a snapshot was deleted and a reload is needed after close
        this.reportService.snapshotDeleted = true;
        this.dialogRef.close(snapshotId);
    }

    cancelClick() {
        // this.deleteSnapshotEvent.emit(false);
        this.dialogRef.close();
    }

    ngOnDestroy() {
    }

}